module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-gh"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__gh"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "logo",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/grasshopper/Grasshopper.jpg"
    }
  })]), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/static/assets/videos/case-study/grasshopper/gh-animation.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "header",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/grasshopper/Grasshopper_header.jpg",
      "alt": ""
    }
  })])])])], 1)])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n        Grasshopper\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Conversant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("09/2016 - Present")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n              Grasshopper is an Adobe Illustrator extension designed and built to aid Art Directors and Production Artists in building digital advertisement units. It exports HTML5 and JavaScript units with a click of a button.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Technology Stack")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• AngularJS")]), _vm._v(" "), _c('li', [_vm._v("• Sass")]), _vm._v(" "), _c('li', [_vm._v("• Node.js")]), _vm._v(" "), _c('li', [_vm._v("• Express")]), _vm._v(" "), _c('li', [_vm._v("• ExtendScript API")]), _vm._v(" "), _c('li', [_vm._v("• Gulp")]), _vm._v(" "), _c('li', [_vm._v("• Jasmine")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a9f06e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grasshopper.vue
// module id = 173
// module chunks = 1